import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ContactsService } from '../shared/services/contacts.service';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { NotificationService } from '../../shared/notification.service';
import { DeleteContactTagAction, SetTagsForSelectedAction } from '../contacts.actions';
import { getContactsRowsSelector } from '../contacts.reducer';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'cc-row-tags-editor',
  templateUrl: './row-tags-editor.component.html',
  styleUrls: ['./row-tags-editor.component.scss']
})
export class RowTagsEditorComponent implements OnInit {
  public rowTagsList = [];
  public name: string;
  public tag: string;
  public tagSetError: boolean;
  public rowId: number;
  public visible = true;
  public selectable = true;
  public removable = true;
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public tagCtrl = new FormControl();
  public filteredTags: Observable<string[]>;
  public globalTagList: string[] = [];

  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @Output() selectionChange: EventEmitter<MatSelectChange>;
  constructor(
    public contactsService: ContactsService,
    private store: Store<IState>,
    public notificationService: NotificationService
  ) {
    this.filteredTags = this.tagCtrl.valueChanges.pipe(
      startWith(null),
      map((tag: string | null) => (tag ? this._filter(tag) : this.globalTagList.slice()))
    );
  }

  ngOnInit() {
    this.contactsService.getFilterByTags().subscribe(tagList => {
      this.globalTagList = tagList && tagList.length ? tagList : this.globalTagList;
    });

    this.contactsService.onSetTagEditorPosition.subscribe(position => {
      if (position) {
        this.rowId = position.rowId;
      }
    });

    this.store.select(getContactsRowsSelector).subscribe(contacts => {
      const tagRow = contacts.find(item => item.NATIVE_RECORD_ID.toString() === this.rowId.toString());
      this.rowTagsList = tagRow && tagRow.NATIVE_TAGS ? tagRow.NATIVE_TAGS : null;
    });
  }

  add(eventValue, eventInput = null): void {
    const input = eventInput;
    const value = eventValue;

    if ((value || '').trim()) {
      const fullParams = {
        include: [this.rowId],
        tags: [value]
      };
      this.store.dispatch(new SetTagsForSelectedAction(fullParams));
    }

    if (input) {
      input.value = '';
    }
    this.contactsService.rowCollapse();
  }

  remove(tag: string): void {
    if (this.rowTagsList && this.rowTagsList.includes(tag)) {
      this.rowTagsList.filter(item => item !== tag);

      const fullParams = {
        include: [this.rowId],
        tags: [tag]
      };
      this.store.dispatch(new DeleteContactTagAction(fullParams));
      this.contactsService.rowCollapse();
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.rowTagsList && !this.rowTagsList.includes(event.option.viewValue)) {
      this.rowTagsList.push(event.option.viewValue);
      this.tagInput.nativeElement.value = '';
      this.tagCtrl.setValue(null);
    } else {
      console.log(`tag ${event.option.viewValue} is on the list`);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.globalTagList.filter(tag => tag.toLowerCase().indexOf(filterValue) === 0);
  }

  rowEditorExit() {
    this.contactsService.toggleShowRowTagsEditor(false);
  }
}
